import { FaFacebook } from "react-icons/fa6"
import Heading from "../components/heading"
import FacilitiesClub from "../components/campusLife/facilitiesClub"
import Video from "../components/campusLife/video"
import SwimmingPool from "./swimmingPool"
import Sop from "../components/campusLife/sop"
import SwimmingPoolHours, { MyTable } from "../components/campusLife/swimmingPoolHours"
import Gymnasium from "./gymnasium"
import GymnasiumHours from "./gymnasiumHours"
import WifiAndConnectivity from "./wifiAndConnectivity"
import NeedTechnicalSupport from "./needTechnicalSupport"
import { useSelector } from "react-redux"
import { DecodeHtml } from "../utils/decodeHtml"
import { retrunAssets } from "../utils/getAssets"
import { useEffect, useState } from "react"

const Facilities = () => {

    const state = useSelector(state => state.campusLifeTab)
    const facilities = state?.data?.properties
    const sportsCulturalFacilityDescription = DecodeHtml({ html: facilities?.sportsCulturalFacilityDescription?.markup })
    const uNITENStudentAffairsFacebookLinkURL = facilities?.uNITENStudentAffairsFacebookLinkURL

    const sports = facilities?.imageWithLabel?.items?.map(item => {
        let sport = item?.content?.properties
        return (
            {
                img: sport?.image !== null ? retrunAssets(sport?.image[0]?.url) : "",
                description: sport?.label
            }
        )
    })
    const [tableData, setTableData] = useState({
        headers: [],
        mobile: [],
        contents: []
    });

    useEffect(() => {
        const headers = [];
        const mobile = [];
        const contents = [];

        facilities?.table?.items.forEach((item) => {
            // Extract the label for the header
            const headerLabel = item?.content?.properties?.label;
            headers.push(headerLabel);
            mobile.push(headerLabel);

            const rowData = [];
            item?.content?.properties?.content?.items?.forEach((contentItem) => {
                // Extract the content for each cell
                const cellContent = contentItem?.content?.properties?.richText?.markup;
                rowData.push(DecodeHtml({ html: cellContent }));
            });
            contents.push(rowData);
        });

        setTableData({ headers, mobile, contents });
    }, [facilities?.table]);


    return (
        <div className="flex flex-col items-center gap-5 py-8 w-full">
            <Heading name="Facilities" color="text-blue-700" />
            <h1 className="w-auto  text-center text-slate-900 text-4xl font-bold  capitalize">Sports & Cultural Facility</h1>
            <div className="w-auto flex flex-col items-center gap-5 text-center max-w-5xl">
                <p className="text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{sportsCulturalFacilityDescription}</p>
                <a href={uNITENStudentAffairsFacebookLinkURL} target="_blank" rel="noreferrer" className="text-sky-950 text-opacity-70 text-base font-normal flex items-center gap-3  underline leading-normal">
                    <span className="text-blue-300">
                        <FaFacebook size={25} />
                    </span>
                    UNITEN Student Affairs Facebook</a>
            </div>
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {
                    sports?.map((sport, index) => (
                        <div key={index} className="flex flex-col items-center gap-5">
                            <img src={sport.img} alt="" className="w-full h-[25rem] object-cover rounded-2xl" />
                            <span className="text-blue-700 text-sm font-bold  ">{sport.description}</span>
                        </div>
                    ))
                }
            </div>

            <div className="flex w-full my-8 items-center justify-center">
                <MyTable headers={tableData.headers} mobile={tableData.mobile} contents={tableData.contents} />

            </div>
            <FacilitiesClub />

            <div className="my-8 w-full flex items-center justify-center">
                <Video path="https://www.youtube.com/embed/4mErz5yzigs?si=_5KNbMUSOOOVozDI" />
            </div>
            <SwimmingPool />
            <Sop sops={facilities?.swimmingPoolSOP?.markup} />
            <SwimmingPoolHours />
            <Gymnasium />
            <GymnasiumHours />
            <WifiAndConnectivity />
            <NeedTechnicalSupport />

        </div>
    )
}

export default Facilities